module.exports = __webpack_public_path__ + "img/DSC_2851.0daa57de.png";